import { render, staticRenderFns } from "./AllSingleProcess.vue?vue&type=template&id=ca0447c6&"
import script from "./AllSingleProcess.vue?vue&type=script&lang=js&"
export * from "./AllSingleProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports